const localeConstants = {
  "US": {
    currency: "$",
    ButtonText: "Buy Now",
    viewDetails:"View Details",
    ResetButton: "Reset Filters",
    sortLabel: "Sort By:",
    LowestPrice: "Lowest Price",
    HighestPrice: "Highest Price",
    FeaturedProducts: "Featured Products",
    Rating: "Rating",
    DiscountedPrice: "Discounted Price",
    PriceFilter: "Price",
    ResultFound: "results found",
    ViewButton: "View",
    storeLang: "NALA",
    backToStore: "Back to Store",
    showMore: "Show More",
    showLess: "Show Less",
    more: "More",
    homeTab: "home",
    featuredLabel:"Featured",
    filterlabels: {
      category: "Product Category",
      manufacturer: "Manufacturer",
      nv_technology: "NVIDIA technology",
      Stock: "Stock",
      gpu: "GPU",
      screen_size:"Screen Size",
      ram :"System Memory",
      gpu_memory_size:"GPU Memory Size",
      video_memory:"Video Memory",
      product:"Product",
      price: "Price"
    },
    filterCategories: {
      gpu: "Graphics Cards",
      laptop: "Gaming Laptops",
      desktop: "Gaming Desktops",
      price: "Price",
      creator_laptops: "NVIDIA Studio",
      jetson_developer_kit: "Developer Kit",
      studio_laptop: "Studio Laptops"
    },
    productInfo: {
      // gpu: "Graphics Card",
      // display_type: "Display type",
      // cpu_processor: "CPU Processor",
      // memory: "GPU Memory Size",
      // storage: "Storage",
      gpu_boost_clock_speed: "Boost Clock Speed",
      gpu_memory_size: "GPU Memory Size",
      // cooling_system: "Cooling System",
    },
  },
  "FR": {
    currency: "$",
    ButtonText: "Acheter maintenant",
    viewDetails: "Voir les détails",
    ResetButton: "Réinitialiser les filtres",
    sortLabel: "Trier par :",
    LowestPrice: "Prix le plus bas",
    HighestPrice: "Prix le plus élevé",
    FeaturedProducts: "Produits Vedettes",
    Rating: "Évaluation",
    DiscountedPrice: "Prix Réduit",
    PriceFilter: "Prix",
    ResultFound: "résultats trouvés",
    ViewButton: "Voir",
    storeLang: "NALA",
    backToStore: "Retour à la boutique",
    showMore: "Voir plus",
    showLess: "Voir moins",
    more: "Plus",
    homeTab: "page d`accueil",
    loadMore:"Plus",
    featuredLabel: "En vedette",
    noProduct: "Bientôt disponible.",
    filterlabels: {
        category: "Catégorie de produit",
        manufacturer: "Fabricant",
        gpu: "Carte graphique",
        price: "Prix"
    },
    filterCategories: {
        gpu: "Cartes graphiques",
        laptop: "Ordinateurs portables de jeu",
        desktop: "Ordinateurs de bureau de jeu",
        price: "Prix",
        creator_laptops: "NVIDIA Studio",
        jetson_developer_kit: "Kit de développement",
        studio_laptop: "Ordinateurs portables de studio"
    },
    productInfo: {
        gpu: "Carte graphique",
        display_type: "Type d'affichage",
        cpu_processor: "Processeur CPU",
        memory: "Taille de la mémoire GPU",
        storage: "Stockage",
        gpu_boost_clock_speed: "Fréquence d'horloge Boost GPU",
        gpu_memory_size: "Taille de la mémoire GPU",
        cooling_system: "Système de refroidissement"
    }
},
  "CA": {
    currency: "$",
    ButtonText: "Buy Now",
    viewDetails:"View Details",
    ResetButton: "Reset Filters",
    sortLabel: "Sort By:",
    LowestPrice: "Lowest Price",
    HighestPrice: "Highest Price",
    FeaturedProducts: "Featured Products",
    Rating: "Rating",
    DiscountedPrice: "Discounted Price",
    PriceFilter: "Price",
    ResultFound: "results found",
    ViewButton: "View",
    storeLang: "NALA",
    backToStore: "Back to Store",
    showMore: "Show More",
    showLess: "Show Less",
    more: "More",
    homeTab: "home",
    featuredLabel:"Featured",
    filterlabels: {
      category: "Product Category",
      manufacturer: "Manufacturer",
      gpu: "GPU",
      price: "Price",
    },
    filterCategories: {
      gpu: "Graphics Cards",
      laptop: "Gaming Laptops",
      desktop: "Gaming Desktops",
      price: "Price",
      CREATOR_LAPTOPS: "NVIDIA Studio"
    },
    productInfo: {
      gpu: "Graphics Card",
      display_type: "Display type",
      cpu_processor: "CPU Processor",
      memory: "GPU Memory Size",
      storage: "Storage",
      gpu_boost_clock_speed: "Boost Clock Speed",
      gpu_memory_size: "GPU Memory Size",
      cooling_system: "Cooling System",
    },
  },
  "UK": {
    currency: "£",
    ButtonText: "Buy Now",
    viewDetails:"View Details",
    ResetButton: "Reset Filters",
    sortLabel: "Sort By:",
    LowestPrice: "Lowest Price",
    HighestPrice: "Highest Price",
    PriceFilter: "Price",
    ResultFound: "results found",
    ViewButton: "View",
    storeLang: "NALA",
    backToStore: "Back to Store",
    showMore: "Show More",
    showLess: "Show Less",
    more: "More",
    homeTab: "home",
    featuredLabel:"Featured",
    filterlabels: {
      category: "Product Category",
      manufacturer: "Manufacturer",
      nv_technology: "NVIDIA technology",
      Stock: "Stock",
      gpu: "GPU",
      screen_size:"Screen Size",
      ram :"System Memory",
      gpu_memory_size:"GPU Memory Size",
      video_memory:"Video Memory",
      product:"Product",
      price: "Price"
    },
    filterCategories: {
      gpu: "Graphics Cards",
      laptop: "Gaming Laptops",
      desktop: "Gaming Desktops",
      price: "Price",
      CREATOR_LAPTOPS: "NVIDIA Studio"
    },
    productInfo: {
      gpu: "Graphics Card",
      display_type: "Display type",
      cpu_processor: "CPU Processor",
      memory: "GPU Memory Size",
      storage: "Storage",
      gpu_boost_clock_speed: "Boost Clock Speed",
      gpu_memory_size: "GPU Memory Size",
      cooling_system: "Cooling System",
    },
  },
  "AU": {
    currency: "$",
    ButtonText: "Buy Now",
    viewDetails:"View Details",
    ResetButton: "Reset Filters",
    sortLabel: "Sort By:",
    LowestPrice: "Lowest Price",
    HighestPrice: "Highest Price",
    PriceFilter: "Price",
    ResultFound: "results found",
    ViewButton: "View",
    storeLang: "NALA",
    backToStore: "Back to Store",
    showMore: "Show More",
    showLess: "Show Less",
    more: "More",
    homeTab: "home",
    featuredLabel:"Featured",
    filterlabels: {
      category: "Product Category",
      manufacturer: "Manufacturer",
      gpu: "GPU",
      price: "Price",
    },
    filterCategories: {
      gpu: "Graphics Cards",
      laptop: "Gaming Laptops",
      desktop: "Gaming Desktops",
      price: "Price",
      CREATOR_LAPTOPS: "NVIDIA Studio"
    },
    productInfo: {
      gpu: "Graphics Card",
      display_type: "Display type",
      cpu_processor: "CPU Processor",
      memory: "GPU Memory Size",
      storage: "Storage",
      gpu_boost_clock_speed: "Boost Clock Speed",
      gpu_memory_size: "GPU Memory Size",
      cooling_system: "Cooling System",
    },
  },
  "BR": {
    currency: "R$",
    ButtonText: "Compre Agora",
    viewDetails:"Ver detalhes",
    ResetButton: "FILTROS",
    sortLabel: "Listar por:",
    LowestPrice: "Preço crescente",
    HighestPrice: "Preço decrescente",
    PriceFilter: "Preço",
    ResultFound: "Resultados Encontrados",
    ViewButton: "Ver",
    storeLang: "LATM",
    backToStore: "VOLTAR À LOJA",
    showMore: "Mostrar Mais",
    showLess: 'Mostrar Menos',
    offerText: 'DE DESCONTO NO BOLETO',
    oldPriceText: 'De por',
    more: "MAIS",
    homeTab: "home",
    featuredLabel:"Presentado",
    filterlabels: {
      category: "Categorias de Produtos",
      manufacturer: "Marcas",
      gpu: "GPU",
      price: "Preço",
    },
    filterCategories: {
      gpu: "Placas de Vídeo",
      laptop: "Gaming Laptops",
      desktop: "Gaming Desktops",
      price: "Price",
    },
    productInfo: {
      gpu: "Graphics Card",
      display_type: "Display type",
      cpu_processor: "CPU Processor",
      memory: "GPU Memory Size",
      storage: "Storage",
      gpu_boost_clock_speed: "Boost Clock Speed",
      gpu_memory_size: "GPU Memory Size",
      cooling_system: "Cooling System",
    },
  },
  "PH": {
    currency: "₱",
    ButtonText: "Buy Now",
    viewDetails:"View Details",
    ResetButton: "Reset Filters",
    sortLabel: "Sort By:",
    LowestPrice: "Lowest Price",
    HighestPrice: "Highest Price",
    PriceFilter: "Price",
    ResultFound: "results found",
    ViewButton: "View",
    storeLang: "NALA",
    backToStore: "Back to Store",
    showMore: "Show More",
    showLess: "Show Less",
    more: "More",
    homeTab: "home",
    featuredLabel:"Featured",
    filterlabels: {
      category: "Product Category",
      manufacturer: "Manufacturer",
      gpu: "GPU",
      price: "Price",
    },
    filterCategories: {
      gpu: "Graphics Cards",
      laptop: "Gaming Laptops",
      desktop: "Gaming Desktops",
      price: "Price",
      CREATOR_LAPTOPS: "NVIDIA Studio"
    },
    productInfo: {
      gpu: "Graphics Card",
      display_type: "Display type",
      cpu_processor: "CPU Processor",
      memory: "GPU Memory Size",
      storage: "Storage",
      gpu_boost_clock_speed: "Boost Clock Speed",
      gpu_memory_size: "GPU Memory Size",
      cooling_system: "Cooling System",
    },
  },
  "AR": {
    currency: "$",
    ButtonText: "Comprar ahora",
    viewDetails:"Ver detalles",
    ResetButton: "Restablecer filtros",
    sortLabel: "Ordenar por:",
    LowestPrice: "Precio ascendente",
    HighestPrice: "Precio descendente",
    PriceFilter: "Preço",
    ResultFound: "Resultados Encontrados",
    ViewButton: "Ver",
    storeLang: "LATM",
    backToStore: "VOLTAR À LOJA",
    showMore: "Mostrar Mais",
    showLess: 'Mostrar Menos',
    more: "MAIS",
    homeTab: "inicio",
    featuredLabel:"Presentado",
    filterlabels: {
      category: "Categorias de Produtos",
      manufacturer: "Marcas",
      gpu: "GPU",
      price: "Preço",
    },
    filterCategories: {
      gpu: "Placas de Vídeo",
      laptop: "Gaming Laptops",
      desktop: "Gaming Desktops",
      price: "Preço",
    },
    productInfo: {
      gpu: "Graphics Card",
      display_type: "Display type",
      cpu_processor: "CPU Processor",
      memory: "GPU Memory Size",
      storage: "Storage",
      gpu_boost_clock_speed: "Boost Clock Speed",
      gpu_memory_size: "GPU Memory Size",
      cooling_system: "Cooling System",
    },
  },
  "ES-AR": {
    currency: "$",
    ButtonText: "Comprar ahora",
    viewDetails:"Ver detalles",
    ResetButton: "Restablecer filtros",
    sortLabel: "Ordenar por:",
    LowestPrice: "Preço crescente",
    HighestPrice: "Preço decrescente",
    PriceFilter: "Preço",
    ResultFound: "Resultados Encontrados",
    ViewButton: "Ver",
    storeLang: "LATM",
    backToStore: "VOLTAR À LOJA",
    showMore: "Mostrar Mais",
    showLess: 'Mostrar Menos',
    more: "MAIS",
    homeTab: "inicio",
    featuredLabel:"Presentado",
    filterlabels: {
      category: "Categorias de Produtos",
      manufacturer: "Marcas",
      gpu: "GPU",
      price: "Preço",
    },
    filterCategories: {
      gpu: "Placas de Vídeo",
      laptop: "Gaming Laptops",
      desktop: "Gaming Desktops",
      price: "Preço",
    },
    productInfo: {
      gpu: "Graphics Card",
      display_type: "Display type",
      cpu_processor: "CPU Processor",
      memory: "GPU Memory Size",
      storage: "Storage",
      gpu_boost_clock_speed: "Boost Clock Speed",
      gpu_memory_size: "GPU Memory Size",
      cooling_system: "Cooling System",
    },
  },
  "ES": {
    currency: "€",
    ButtonText: "Comprar ahora",
    viewDetails:"Ver detalles",
    ResetButton: "Restablecer filtros",
    sortLabel: "Ordenar por:",
    LowestPrice: "Precio menor",
    HighestPrice: "Precio mayor",
    PriceFilter: "Precio",
    ResultFound: "Resultados Encontrados",
    ViewButton: "Ver",
    storeLang: "LATM",
    backToStore: "VOLTAR À LOJA",
    showMore: "Mostrar Mais",
    showLess: 'Mostrar Menos',
    more: "MAIS",
    homeTab: "inicio",
    featuredLabel:" ",
    filterlabels: {
      category: "Categorias de Produtos",
      manufacturer: "Marcas",
      gpu: "GPU",
      price: "Precio",
      stock:"Stock"
    },
    filterCategories: {
      gpu: "Placas de Vídeo",
      laptop: "Gaming Laptops",
      desktop: "Gaming Desktops",
      price: "Precio",
      stock:"Stock"
    },
    productInfo: {
      gpu: "Graphics Card",
      display_type: "Display type",
      cpu_processor: "CPU Processor",
      memory: "GPU Memory Size",
      storage: "Storage",
      gpu_boost_clock_speed: "Boost Clock Speed",
      gpu_memory_size: "GPU Memory Size",
      cooling_system: "Cooling System",
    },
  },
  "MX": {
    currency: "$",
    ButtonText: "COMPRAR",
    viewDetails:"ver detalles",
    ResetButton: "Restablecer filtros",
    sortLabel: "Ordenar por:",
    LowestPrice: "Menor precio",
    HighestPrice: "Mayor precio",
    PriceFilter: "Precio",
    ResultFound: "Resultados Encontrados",
    ViewButton: "Ver",
    storeLang: "LATM",
    backToStore: "VOLTAR À LOJA",
    showMore: "Ver más",
    showLess: 'Ver menos',
    more: "Más",
    homeTab: "inicio",
    featuredLabel:"Presentado",
    filterlabels: {
      category: "Categorias de Produtos",
      manufacturer: "Marcas",
      gpu: "GPU",
      price: "Precio",
    },
    filterCategories: {
      gpu: "Tarjetas gráficas",
      laptop: "Gaming Laptops",
      desktop: "Gaming Desktops",
      price: "Precio",
    },
    productInfo: {
      gpu: "Graphics Card",
      display_type: "Display type",
      cpu_processor: "CPU Processor",
      memory: "GPU Memory Size",
      storage: "Storage",
      gpu_boost_clock_speed: "Boost Clock Speed",
      gpu_memory_size: "GPU Memory Size",
      cooling_system: "Cooling System",
    },
  },
  "KR": {
    currency: "₩",
    ButtonText: "구매하기",
    viewDetails:"세부 정보보기",
    ResetButton: "필터 재설정",
    sortLabel: "정렬 기준:",
    LowestPrice: "낮은 가격 순",
    HighestPrice: "높은 가격 순",
    PriceFilter: "가격",
    ResultFound: "의 상품이 있습니다",
    ViewButton: "보기 방식",
    storeLang: "APAC",
    backToStore: "스토어로 돌아가기",
    showMore: "자세히보기",
    showLess: '적게 표시',
    more: "더",
    homeTab: "home",
    featuredLabel:"추천",
    noProduct: "곧 온다",
    filterlabels: {
      category: "제품 카테고리",
      manufacturer: "제조사",
      gpu: "GPU",
      price: "가격"
    },
    filterCategories: {
      gpu: "그래픽 카드",
      laptop: "게임용 노트북",
      desktop: "게임용 데스크탑",
      price: "가격",
      CREATOR_LAPTOPS: "엔비디아 스튜디오",
      jetson_developer_kit: "개발자 키트"
    },
    productInfo: {
      gpu: "그래픽 카드",
      display_type: "Display type",
      cpu_processor: "CPU Processor",
      memory: "GPU Memory Size",
      storage: "Storage",
      gpu_boost_clock_speed: "Boost Clock Speed",
      gpu_memory_size: "GPU Memory Size",
      cooling_system: "Cooling System",
    },
  },
  "DE": {
    currency: "€",
    ButtonText: "Kaufe jetzt",
    viewDetails:"Details anzeigen",
    ResetButton: "Filter zurücksetzen",
    sortLabel: "Sortieren nach:",
    LowestPrice: "Geringster Preis",
    HighestPrice: "Höchster Preis",
    PriceFilter: "Preis",
    ResultFound: "Gefundene Ergebnisse",
    ViewButton: "View",
    storeLang: "NALA",
    backToStore: "Back to Store",
    showMore: "Zeig mehr",
    showLess: "Zeige weniger",
    more: "Mehr",
    homeTab: "home",
    featuredLabel:"Hervorgehoben",
    filterlabels: {
      category: "Product Category",
      manufacturer: "Manufacturer",
      gpu: "GPU",
      price: "Price"
    },
    filterCategories: {
      gpu: "Graphics Cards",
      laptop: "Gaming Laptops",
      desktop: "Gaming Desktops",
      price: "Price",
      creator_laptops: "NVIDIA Studio",
      jetson_developer_kit: "Developer Kit",
      studio_laptop: "Studio Laptops"
    },
    productInfo: {
      gpu: "Graphics Card",
      display_type: "Display type",
      cpu_processor: "CPU Processor",
      memory: "GPU Memory Size",
      storage: "Storage",
      gpu_boost_clock_speed: "Boost Clock Speed",
      gpu_memory_size: "GPU Memory Size",
      cooling_system: "Cooling System",
    },
  },
  "CZ": {
    currency: "Kč",
    ButtonText: "Kup nyní",
    viewDetails:"Zobrazit podrobnosti",
    ResetButton: "Resetovat filtry",
    sortLabel: "Seřazeno podle:",
    LowestPrice: "Nejnižší cena",
    HighestPrice: "Nejvyšší cena",
    PriceFilter: "Cena",
    ResultFound: "nalezeny výsledky",
    ViewButton: "Pohled",
    storeLang: "NALA",
    backToStore: "Zpět do obchodu",
    showMore: "Zobrazit více",
    showLess: "Ukaž méně",
    more: "Více",
    homeTab: "domů",
    loadMore:"Načíst další",
    featuredLabel:"Doporučujeme",
    filterlabels: {
      category: "kategorie produktů",
      manufacturer: "Výrobce",
      gpu: "GPU",
      price: "Cena"
    },
    filterCategories: {
      gpu: "Graphics Cards",
      laptop: "Gaming Laptops",
      desktop: "Gaming Desktops",
      price: "Price",
      creator_laptops: "NVIDIA Studio",
      jetson_developer_kit: "Developer Kit",
      studio_laptop: "Studio Laptops"
    },
    productInfo: {
      gpu: "Graphics Card",
      display_type: "Display type",
      cpu_processor: "CPU Processor",
      memory: "GPU Memory Size",
      storage: "Storage",
      gpu_boost_clock_speed: "Boost Clock Speed",
      gpu_memory_size: "GPU Memory Size",
      cooling_system: "Cooling System",
    },
  },  
  "VN":{
    currency: "đ",
    ButtonText: "mua ngay",
    viewDetails:"Xem chi tiết",
    ResetButton: "Đặt lại bộ lọc",
    sortLabel: "Sắp xếp theo:",
    LowestPrice: "Giá thấp nhất",
    HighestPrice: "Giá cao nhất",
    PriceFilter: "Giá bán",
    ResultFound: "kết quả tìm thấy",
    ViewButton: "Lượt xem",
    storeLang: "VN",
    backToStore: "Trở lại cửa hàng",
    showMore: "Cho xem nhiều hơn",
    showLess: "Hiện ít hơn",
    more: "Hơn",
    homeTab: "home",
    featuredLabel:"Đặc sắc",
    filterlabels: {
      category: "Product Category",
      manufacturer: "Manufacturer",
      gpu: "GPU",
      price: "Price"
    },
    filterCategories: {
      gpu: "Graphics Cards",
      laptop: "Gaming Laptops",
      desktop: "Gaming Desktops",
      price: "Price",
      creator_laptops: "NVIDIA Studio",
      jetson_developer_kit: "Developer Kit",
      studio_laptop: "Studio Laptops"
    },
    productInfo: {
      gpu: "Graphics Card",
      display_type: "Display type",
      cpu_processor: "CPU Processor",
      memory: "GPU Memory Size",
      storage: "Storage",
      gpu_boost_clock_speed: "Boost Clock Speed",
      gpu_memory_size: "GPU Memory Size",
      cooling_system: "Cooling System",
    }
  },
  "TW":{
    currency: "$",
    ButtonText: "立即購買",
    viewDetails: "查看詳情",
    ResetButton: "重置篩選",
    sortLabel: "排序方式：",
    LowestPrice: "最低價格",
    HighestPrice: "最高價格",
    PriceFilter: "價格",
    ResultFound: "個結果",
    ViewButton: "查看",
    storeLang: "NALA",
    backToStore: "返回商店",
    showMore: "顯示更多",
    showLess: "顯示較少",
    more: "更多",
    homeTab: "首頁",
    featuredLabel: "特色",
    filterlabels: {
      category: "產品類別",
      manufacturer: "製造商",
      gpu: "顯示卡",
      price: "價格"
    },
    filterCategories: {
      gpu: "顯示卡",
      laptop: "遊戲筆記型電腦",
      desktop: "遊戲桌上型電腦",
      price: "價格",
      creator_laptops: "NVIDIA Studio",
      jetson_developer_kit: "開發套件",
      studio_laptop: "工作站筆記型電腦"
    },
    productInfo: {
      gpu: "顯示卡",
      display_type: "顯示器類型",
      cpu_processor: "處理器",
      memory: "顯示卡記憶體大小",
      storage: "儲存空間",
      gpu_boost_clock_speed: "顯示卡提升時脈速度",
      gpu_memory_size: "顯示卡記憶體大小",
      cooling_system: "散熱系統"
    
  }
}
};


export default localeConstants;
